import {Jumbotron} from "react-bootstrap";

const AboutMe = () => {
    return ( 
        <Jumbotron>
            <h1>About Me</h1>        
        </Jumbotron>
    );
}
 
export default AboutMe;